/**
 * 加号图标
 */
const AddIcon = ({ width = 18, height = 18, color = '#000000' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none">
      <path d="M9 1.5L9 16.5" stroke={color} strokeWidth="1.66667" strokeLinecap="square" />
      <path d="M1.5 9H16.5" stroke={color} strokeWidth="1.66667" strokeLinecap="square" />
    </svg>
  )
}

export default AddIcon
